module.exports = __webpack_public_path__ + "img/許文華_21-15.2f1b6d81.jpg";